<template>
  <div class="about ld-background ld-right-slide ld-scroll-y">
    <v-layout class="ld-height-100 px-4" wrap>
      <v-flex xs12 class="ld-height-50 pt-3">
        <div class="ld-height-100 text-xs-center">
          <iframe width="90%" height="100%" src="https://www.youtube.com/embed/GRNFoB2rWzo" frameborder="0" allowfullscreen></iframe>
        </div>
      </v-flex>
      <v-layout class="ld-height-50" wrap>
        <v-flex xs12 class="mt-2">
          <h3 class="ld-about-text-title" :class="{'pr-5' : screenWidthSmall}">
            What is Lollicup Denver?
          </h3>
          <div class="ld-about-text">
            Boba, originally from Taiwan, is used in everything from smoothies to tea. There, a business called Lollicup was created
            to specialize in drinks that go well with boba and other delicious add-ins, such as jelli, and pudding. It was a very
            popular drink for children and became a common after-school hangout, and soon, Lollicup took off, opening up in places
            around the world. Lollicup Denver opened in April of 2003, and since then, it has grown as a company to be a busy hot
            spot in Denver and has helped to make Boba more popular in Colorado, serving hundreds of drink combinations with more
            than 20 different add-ins. Check us out and join the Lollicup Denver family!
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'aboutComponent',

    props: ['screenWidthSmall'],

    data() {
      return {};
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/about_component.vue